import "antd/lib/menu/style";
import _Menu from "antd/lib/menu";
import 'antd/lib/menu/style';
import "./style/index.less";
export default _Menu;